import { render, staticRenderFns } from "./que-es-inyeccion-de-plasticos.vue?vue&type=template&id=c5ed6b84&lang=html"
import script from "./que-es-inyeccion-de-plasticos.vue?vue&type=script&lang=js"
export * from "./que-es-inyeccion-de-plasticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports